import { render, staticRenderFns } from "./editPost.vue?vue&type=template&id=0dfcf3c2&scoped=true&"
import script from "./editPost.vue?vue&type=script&lang=js&"
export * from "./editPost.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dfcf3c2",
  null
  
)

export default component.exports